import { render, staticRenderFns } from "./CreateNewMentorshipModal.vue?vue&type=template&id=0db90961&scoped=true&"
import script from "./CreateNewMentorshipModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewMentorshipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db90961",
  null
  
)

export default component.exports